export interface DataSourceParams<Params, Extra> {
  params?: Params;
  extra?: Extra;
}
